// extracted by mini-css-extract-plugin
export var clips = "index-module--clips--y1Dew";
export var clipsContainer = "index-module--clips-container--052LZ";
export var clip1 = "index-module--clip-1--4q55o";
export var clip2 = "index-module--clip-2--jS+qh";
export var clip3 = "index-module--clip-3--WXnSf";
export var clip4 = "index-module--clip-4--TsSOg";
export var clip5 = "index-module--clip-5--gAtiA";
export var clip6 = "index-module--clip-6--ukgr8";